import { render, staticRenderFns } from "./event-summary.vue?vue&type=template&id=fe098c2c&scoped=true&"
import script from "./event-summary.vue?vue&type=script&lang=js&"
export * from "./event-summary.vue?vue&type=script&lang=js&"
import style0 from "./event-summary.vue?vue&type=style&index=0&id=fe098c2c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe098c2c",
  null
  
)

export default component.exports